import { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import ReportComp from "../../components/ReportComp";
import { AppContext } from "../../contexts/AppContext";

const Report: React.FC = () => {
  const { findAndSetStore } = useContext(AppContext);
  const { storeId } = useParams<{ storeId: string }>();
  useEffect(() => {
    if (!storeId) return;
    findAndSetStore(storeId);
  }, [storeId]);

  return <ReportComp />;
};

export default Report;
